import { withInstallFunction } from '@zoryn/utils'
import Notify from './src/notify'

export const ZNotification = withInstallFunction(Notify, '$notify')
export default ZNotification

export * from './src/notification'
